import { useMemo } from "react";
import ReactSelect from "react-select";
import { colourStyles } from "../utils/reactSelectConfig";
// styles
import styles from "../styles/Select.module.css";

interface ISelect {
  id?: string;
  label?: string;
  description?: string;
  optionsList: any[];
  onChange: (v: any | string | null) => void;
  value: string;
  className?: string;
  disabled: boolean;
  disablePadding?: boolean;
}

const Select: React.FC<ISelect> = ({
  id,
  label,
  description,
  optionsList,
  onChange,
  disabled,
  value,
  className,
  disablePadding = true
}) => {
  const options = useMemo(() => {
    return optionsList?.map(el => ({ ...el, label: el?.name }))
  }, [optionsList])

  return (
    <div className={`${styles.customSelect} ${className}`} style={{ zIndex: 999, padding: disablePadding ? "0" : undefined }}>
      {description && <p className={styles.inputDescription}>{description}</p>}
      {label && <label className={styles.inputLabel} htmlFor={id}>{label}</label>}
          <ReactSelect
              inputId={id}
              value={options.filter((el) => el.value === value)[0]}
              defaultValue={options[0]}
              captureMenuScroll={true}
              menuPortalTarget={document.body}
              options={options}
              isDisabled={disabled}
              components={{
                IndicatorSeparator:() => null
              }}
              classNamePrefix="custom-react-select"
              onChange={(value: any) => {
                if (value) {
                  onChange(value.value);
                }
              }}
              styles={colourStyles}
              theme={(theme) => ({
                ...theme,
                borderRadius: 6,
                padding: 0,
                colors: {
                  ...theme.colors,
                  primary: 'var(--fow-gray-light-color)',
                },
              })}
          />
    </div>
  );
};

export default Select;
